import {register} from '../vendor/theme-scripts/theme-sections';
import {slider} from '../features/slider';
import blockScroll from '../features/block-scroll';

register('reviews', [slider, blockScroll]);
